import axios from 'axios'

import config from '../config/config'

export async function uploadImages(data) {
    let newData = []
    console.log(data)

    if (data.length > 0) {
        try {

            for (let i = 0; i < data.length; i++) {

                // console.log(data[i].name)

                const name = (new Date().toLocaleDateString() + "-" + data[i].name.split(' ').join(''))
                    .replace(/\s+/g, '-')        // replace spaces with dashes
                    .replace(/[^a-zA-Z0-9.-]/g, '') // remove special chars
                    .toLowerCase();

                const formData = new FormData();
                formData.append('image', data[i].file);
                formData.append('name', name);

                const res = await axios.post(`${config.apiUrl}/api/uploadImage`, formData);

                if (res) {
                    newData.push({
                        ...data[i],
                        url: `${res.data.key}`
                    })
                }
            }

        } catch (error) {
            console.log(error)
        }
    }

    return newData

}
